var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlayCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M7.666 9.733V6.267L9.54 8 7.666 9.733zm.56-4.765c-.332-.308-.817-.388-1.234-.204-.407.177-.659.556-.659.989v4.494c0 .433.252.812.659.99.148.065.306.096.462.096.282 0 .558-.103.771-.3l2.428-2.247c.22-.204.347-.49.347-.786 0-.296-.126-.582-.347-.786L8.226 4.968zM8 13.333c-2.941 0-5.334-2.392-5.334-5.333C2.666 5.06 5.06 2.667 8 2.667c2.94 0 5.333 2.392 5.333 5.333 0 2.94-2.393 5.333-5.333 5.333m0-12c-3.676 0-6.667 2.99-6.667 6.667 0 3.676 2.99 6.667 6.667 6.667 3.676 0 6.666-2.991 6.666-6.667 0-3.676-2.99-6.667-6.666-6.667",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlayCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/play-circle.dc3fea9f.svg";
export { ForwardRef as ReactComponent };